const VUE_APP_API_HEMERA_URL = document.querySelector("body").getAttribute("api_hemera_url");

export default VUE_APP_API_HEMERA_URL
